import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      width: "100%",
    },

    contentWrapper: {
      position: "relative",
      boxShadow: theme.shadows[1],
      padding: "34px 28px 34px 28px",
      borderRadius: 2,
      backgroundColor: theme.palette.common.white,

      "& .title": {
        display: "block",
        fontSize: "1.1rem",
        fontWeight: 600,
        textAlign: "center",
      },

      "& .subTitle": {
        display: "block",
        fontSize: "0.8rem",
        fontWeight: 400,
        textAlign: "center",
      },

      "& .errorWrapper": {
        display: "block",
        fontSize: "0.8rem",
        fontWeight: 400,
        color: theme.palette.error.main,
      },
    },
    faqWrapper: {
      padding: "20px 30px 16px 30px",
      borderRadius: 2,
      backgroundColor: theme.palette.common.white,
      margin: "20px 0",
      boxShadow: theme.shadows[1],

      "& a": {
        color: theme.palette.secondary.main,
        textDecoration: "none",
        fontSize: 13,
        fontWeight: theme.typography.fontWeightBold,

        "&:hover": {
          textDecoration: "underline",
        },
      },
    },

    paper: {
      border: "none",
    },
  }),
  {
    name: "signin-flow-style",
    flip: null,
  }
);
